import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import { USER_SETTINGS_API_PATHS } from '../../constants';
import type {
    UpdateUserSettingsRequest,
    UserSettingsApi,
} from '../user-settings-api';
import type { UserSettingsResponse } from '../../types';

@injectable()
export class UserSettingsApiImpl extends PsHttpService implements UserSettingsApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getUserSettings(): Promise<UserSettingsResponse> {
        const result = await this.get<PatSnapSuccessResponseData<UserSettingsResponse>>({
            url: USER_SETTINGS_API_PATHS.ROOT,
        });

        return result.data;
    }

    async updateUserSettings(request: UpdateUserSettingsRequest): Promise<UserSettingsResponse> {
        const result = await this.put<PatSnapSuccessResponseData<UserSettingsResponse>>({
            url: USER_SETTINGS_API_PATHS.ROOT,
            data: request,
        });

        return result.data;
    }
}

